module.exports = __webpack_public_path__ + "static/media/basket.bcdbcf6b.png";